import { render, staticRenderFns } from "./InaccessibleSerumInformModal.vue?vue&type=template&id=02a27a4b&scoped=true"
import script from "./InaccessibleSerumInformModal.vue?vue&type=script&lang=js"
export * from "./InaccessibleSerumInformModal.vue?vue&type=script&lang=js"
import style0 from "./InaccessibleSerumInformModal.vue?vue&type=style&index=0&id=02a27a4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a27a4b",
  null
  
)

export default component.exports